import Link from "next/link";
import { useRouter } from "next/router";
import { Fragment, memo, useContext } from "react";
import { AppContext } from "@/contexts/appContexts";
import ArrowIcon from "../icons/ArrowIcon";

function ProductBreadCrumb({ product }) {
  const router = useRouter();
  const { categoryData } = useContext(AppContext);
  const category = (categoryData?.children_data || [])?.find(
    (categoryItem) =>
      categoryItem?.id === product?._category_?.main_category?.category_id
  );

  const BreadCrumbItems = [
    {
      name: product?._category_?.main_category?.name,
      url: category?.url_key,
      active: false,
      key: "products",
    },
    {
      name: product?.name || "",
      url: "",
      active: true,
      key: "product",
    },
  ]?.filter(({ name }) => name);

  return (
    <div className="w-[80%] max-[570px]:w-[98%] mx-auto my-5 max-md:my-2">
      {product && (
        <div className="flex items-center gap-4 p-2 overflow-x-auto bg-white rounded-md max-md:gap-1 max-md:text-xs">
          <Link
            href="/"
            className="duration-200 hover:text-red whitespace-nowrap"
          >
            {router.locale === "en" ? "Home" : "الرئيسية"}
          </Link>
          {BreadCrumbItems?.map((item, index) => (
            <Fragment key={"product-breadcrumb-" + index}>
              <span>
                <ArrowIcon className="w-2 h-2 ltr:rotate-0 rtl:rotate-180" />
              </span>
              {index !== BreadCrumbItems?.length - 1 && item?.url ? (
                <Link
                  href={`/${item?.url}`}
                  className="duration-200 hover:text-red whitespace-nowrap"
                >
                  {item?.name}
                </Link>
              ) : (
                <span className="flex-1 duration-200 text-red whitespace-nowrap">
                  {item?.name}
                </span>
              )}
            </Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(ProductBreadCrumb);
